import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import showNotification from 'components/ui/notification/showNotification';
import { RequestError } from 'types/Api';

interface IRequestConfig extends AxiosRequestConfig {
  errorHandle?: boolean;
}

/**
 * Все запросы к серверу должны осуществляться через функцию request
 * @returns {Promise}
 */
const request = <T>({
  method = 'post',
  url = '',
  data = {},
  responseType = 'json',
  headers = { 'Content-Type': 'application/json' },
  errorHandle = true,
}: IRequestConfig): Promise<AxiosResponse<T>> => {
  return new Promise((resolve, reject) => {
    method = method.toUpperCase();

    let params = { errorHandle };
    if (method === 'GET') {
      params = { ...params, ...data };
    }
    axios({
      method,
      url,
      data,
      headers,
      responseType,
      params,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error: AxiosError<RequestError>) => {
        const { response } = error;

        if (response) {
          reject({
            status: response.status,
            ...response.data
          });
        } else {
          console.error('Network error:', error);
          showNotification({
            status: 'error',
            content: 'Network error',
          });
          reject(error);
        }
      });
  });
};

export default request;
